import * as Yup from 'yup'

export const issuerComplianceRuleValidationSchema = Yup.object().shape({
  rating: Yup.string().required(),
  ratingType: Yup.string().required(),
  maxLimit: Yup.number().required(),
})
